import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as typesAccount from '@account/store/types'
import api from '@home/api'
import PopupLayout from '@appbase/templates/PopupLayout/PopupLayout.vue'
import { EumEditor } from "@appbase/components/editor";

@Component({
    components: {
        PopupLayout, EumEditor
    },
    computed: mapGetters({
        user: typesAccount.USER,
    }),
})
export default class ReportEmail extends Vue {

    user!: account.User;
    managerList: kyoboBook.report.RoleMember[] = []
    selectedManager: kyoboBook.report.RoleMember | null = null
    privacyCheck: boolean = false
    reportContent: kyoboBook.report.ReportForm = { inputPhone: '', inputTitle: '', inputContent: '' }

    synapopts: editor.synap.SynapEditorConfig = {
        'editor.upload.image.base64': true,
        "editor.autoSave": false,
        "editor.autoSave.period": 10,
        "editor.menu.show": true,
    };

    get InputPhone(){
        return this.reportContent.inputPhone
    }
    set InputPhone(val: string){
        this.reportContent.inputPhone = val.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
    }

    getReportManagerList() {
        api.kyobobook.getReportManagerList('REPORT', this.user.comCode).then(res => {
            this.managerList = res
        })
    }

    onSave() {
        this.loadEditorContent()
        if (!this.validationCheck()) {
            return
        }
        api.kyobobook.sendMailToManager(this.selectedManager as kyoboBook.report.RoleMember, this.reportContent).then(res => {
            if(res>0){
                this.onClose()
            }
        })
    }

    onClose() {
        if(this.isTeams){
            this.$emit('cancle')
        }
        window.close()
    }

    validationCheck(): boolean {
        if (!this.privacyCheck) {
            (window as any).alertAsync(this.$t('개인정보_수집_동의'))
            return false
        }
        else if (!this.selectedManager) {
            (window as any).alertAsync(this.$t('고충처리_담당자_선택'))
            return false
        }
        else if(this.reportContent.inputPhone.trim() === ''){
            (window as any).alertAsync(this.$t('연락처를_입력해_주십시오'))
            return false
        }
        else if(!this.numberValidation(this.reportContent.inputPhone)){
            (window as any).alertAsync(this.$t('연락처를_확인해_주십시오'))
            return false
        }
        else if (this.reportContent.inputTitle.trim() === '') {
            (window as any).alertAsync(this.$t('제목을_입력해_주십시오'))
            return false
        }
        else if(this.reportContent.inputContent.trim() === ''){
            (window as any).alertAsync(this.$t('내용을_입력해_주십시오'))
            return false
        }
        return true
    }

    numberValidation(val:string){
        var regPhone= /^\d{2,3}-?\d{3,4}-?\d{4}$/;
        return regPhone.test(val)
    }

    loadEditorContent() {
        const editor: editor.IEditorProxy = this.$refs.editor as any;
        this.reportContent.inputContent = editor.getEditor().getBodyValue();
    }

    onAfterEdit(content: string, e: any) {
        var divContent = document.createElement("div");
        divContent.innerHTML = content;

        var plainText = divContent.textContent || divContent.innerText || "";
        console.log("plainText", plainText);
    }  

    created() {
        this.getReportManagerList()
    }
}
